import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { spinnerTemplate, plotDashboardTemplate, treePopupTemplate, coloresIfnTemplate } from '../data/htmlTemplates.js';

import Mustache from 'mustache';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import L from 'leaflet';
import Chart from 'chart.js/auto';

import { Sesion, Datos, Layers, obtenerURL, cargarURL } from '../main.js';
import { getPlotinfo } from './dataManager.js';
import { getIconoArbol } from './icons.js';
import { getMoreSpecificTaxon, mostrarInfoTaxon, handlerNombreCientifico, getTaxonLabel } from './taxons.js';
import { uriToLiteral, getLiteral, getDate, firstUppercase, configurarModal } from './util.js';
import { initTimedEvent, setEventData, sendTimedEvent, sendEvent } from './events.js';


async function dashboardParcela() {
	// obtengo iri de la parcela
	const piri = Sesion.estado.etid;
	
	// pongo spinner con mensaje de cargando
	document.getElementById("mipagina").innerHTML = spinnerTemplate; 
	window.scrollTo(0, 0);
	
	// inicializo el evento para enviar a GA
	initTimedEvent( { content_type: 'plot', content_id: piri } );
	const logUrls = { cache: 0, red: 0 };

	// pido datos a CRAFTS de la parcela
	if (piri.startsWith(config.prefixes.pifn2)) {
		await getPlotinfo(piri, "ifn2", logUrls);
		if (Datos.parcinfos[piri].plotifn3) {
			const opiris = Array.isArray(Datos.parcinfos[piri].plotifn3)? Datos.parcinfos[piri].plotifn3 : [ Datos.parcinfos[piri].plotifn3 ];
			for (const opiri of opiris)
				await getPlotinfo(opiri, "ifn3", logUrls);
		}
		else if (Sesion.estado.oifns.ifn3)
			delete Sesion.estado.oifns.ifn3;
	}
	else if (piri.startsWith(config.prefixes.pifn3)) {
		await getPlotinfo(piri, "ifn3", logUrls);
		if (Datos.parcinfos[piri].plotifn2) {
			const opiris = Array.isArray(Datos.parcinfos[piri].plotifn2)? Datos.parcinfos[piri].plotifn2 : [ Datos.parcinfos[piri].plotifn2 ];
			for (const opiri of opiris)
				await getPlotinfo(opiri, "ifn2", logUrls);
		}
		else if (Sesion.estado.oifns.ifn2)
			delete Sesion.estado.oifns.ifn2;
	}
	else if (piri.startsWith(config.prefixes.pifn4))
		await getPlotinfo(piri, "ifn4", logUrls);
	// TODO: extraer casos del ifn4 cuando esté
	// no debería haber ningún otro caso...
	
	//console.log(Datos.parcinfos[piri]);
		
	// actualizo info urls para GA
	setEventData('urls_network', logUrls.red);
	setEventData('urls_cache', logUrls.cache);	
		
	// hago el render
	renderDashboard();
}

function renderDashboard(noTimedEvent) {
	// obtengo iri de la parcela
	const piri = Sesion.estado.etid;
		
	// obtengo edición del ifn
	let ifn = null; // preinicializo
	for (const evifn of config.ifnVersions) {
		if (piri.startsWith(config.prefixes['p'+evifn])) {
			ifn = evifn;
			break;
		}
	}
	
	// objeto datos parcelas
	const ifnobjs = {};

	// si no hay un ifn válido o no hay posición asumo que la parcela no existe...	
	if (!ifn || !Datos.parcinfos[piri].lat) {		
		// lo muestro pasado un segundo (porque puede haber un modal anterior que se esté mostrando)
		setTimeout(function(){	
			// pongo página en blanco
			document.getElementById("mipagina").innerHTML = "";
			// pongo un modal para avisar de que no hay parcela
			const body = getLiteral(dict.errorPlotText) + ' "' + Sesion.estado.etid + '".';
			configurarModal( { vertcent: true, nofooter: true},
				getLiteral(dict.errorPlotTitle), body, null);
			const mimodal = new bootstrap.Modal(document.getElementById('mimodal'));
			mimodal.show();
			// handler para volver una vez que se cierra el modal
			document.getElementById('mimodal').addEventListener('hidden.bs.modal', event => {
				// voy para atrás
				goBack();
			}, { once: true })
		}, 1000);
		return;
	}
	
	// cambio la posición de la sesión a la de la parcela si la de sesión coincide con la posición inicial
	if (!Sesion.estado.loc || (Sesion.estado.loc.lat === config.geolocstart[0] 
			&& Sesion.estado.loc.lng === config.geolocstart[1] && Sesion.estado.loc.z === config.zStart) ) {
		Sesion.estado.loc.lat = Datos.parcinfos[piri].lat;
		Sesion.estado.loc.lng = Datos.parcinfos[piri].lng;
		Sesion.estado.loc.z = config.zMaxCelda;
	}
	
	
	// tengo ifn, lo elimino de Sesion.estado.oifns (si estuviera por error)
	delete Sesion.estado.oifns[ifn];
	
	// actualizo url si hace falta
	if (window.location !== obtenerURL())
		history.replaceState(Sesion.estado, "", obtenerURL());	
	
	// aquí guardo los ifns a presentar en el dashboard
	const ifns = [];
	
	// aquí preparo el super-objeto con todos los datos de las parcelas asociadas
	const ifnsobj = {}
	let hayMapa = false; // lo habrá si hay algún árbol que pintar
	for (const ifnev of config.ifnVersions) {
		// NUEVO: sólo incluyo una versión extra si existe y es posible la comparación		
		if (ifn === ifnev || (Datos.parcinfos[piri]["plot"+ifnev] && !Datos.parcinfos[piri].notComparable)) {
			const piriev = ifn === ifnev? piri : Datos.parcinfos[piri]["plot"+ifnev];
			ifnsobj[ifnev] = {
				ifn: ifnev,
				ifnlab: getLiteral(dict[ifnev.toUpperCase()]),
				piri: piriev,				
				pinfo: Datos.parcinfos[piriev],
				checked: ifn === ifnev? true : (Sesion.estado.oifns[ifnev] == true)			
			};
			// si se va a presentar...
			if (ifnsobj[ifnev].checked) {
				// incluyo entre los inventarios a comparar
				ifns.push(ifnev);
				// detecto si tiene árboles
				if (ifnsobj[ifnev].pinfo.trees)
					hayMapa = true;
			}
		}
	}

	// preparo objeto para el render
	const opl = {
		//title: getLiteral(dict.plot) + " " + uriToLiteral(piri, "plot-"),
		nomci: Sesion.nomci,
		hayMapa: hayMapa
	};
	
	// CHECKBOX CON LAS EDICIONES
	if (Object.keys(ifnsobj).length > 1)
		opl.ifnchecks = Object.values(ifnsobj);
	
	// TABLA INICIAL (hacer mejor y para cada inventario a comparar)
	opl.ifnheads = [];
	for (const ifnev of ifns) {
		const ifnhead = {};
		opl.ifnheads.push(ifnhead); // guardo ya
		
		// preparo título y filas
		ifnhead.title = getLiteral(dict.plot) + " " + uriToLiteral(ifnsobj[ifnev].piri, "plot-");
		ifnhead.rows = [];
	
		// preparo cada fila
		// source + color
		let row = {};
		row.head = getLiteral(dict.source);
		// preparo dropdown de colores para cambiar
		const colifnobj = {
			ifn: ifnev,
			color: config.colores[Sesion.colifnind[ifnev]][1],
			colores: []
		}
		const colsno = Object.values(Sesion.colifnind).filter(c => c != Sesion.colifnind[ifnev]);
		const cols = config.coltxinds.filter(c => !colsno.includes(c));
		for (let cind of cols)
			colifnobj.colores.push( {"cind": cind, "label": getLiteral(dict["color"+cind])} );
		const htmlsourcecolor = getLiteral(dict["url"+ifnev]) + Mustache.render(coloresIfnTemplate, colifnobj);
		row.value = htmlsourcecolor;
		ifnhead.rows.push(row);
		ifnhead.titlecolor = colifnobj.color; // guardo también el color del encabezado de la tabla
	
		// dataCapture
		const pinfodc = getDate(ifnsobj[ifnev].pinfo.dataCapture);
		if (pinfodc) {
			row = {};
			row.head = getLiteral(dict.plotDate);
			row.value = pinfodc;
			ifnhead.rows.push(row);
		}
	
		// plotType (IFN3)
		if (ifnsobj[ifnev].pinfo.plotType) {
			row = {};
			row.head = getLiteral(dict.plotType);
			let chunks = ifnsobj[ifnev].pinfo.plotType.split('-');
			let cad = chunks[chunks.length - 1]; // me quedo con el código final
			if (ifnsobj[ifnev].pinfo.plotTypeLabel && getLiteral(ifnsobj[ifnev].pinfo.plotTypeLabel))
				cad += ' - ' + getLiteral(ifnsobj[ifnev].pinfo.plotTypeLabel); // incluyo etiqueta
			row.value = cad;
			ifnhead.rows.push(row);
		}
	
		// soilUse (IFN3)
		if (ifnsobj[ifnev].pinfo.soilUse) {
			row = {};
			row.head = getLiteral(dict.soilUse);
			row.value = getLiteral(ifnsobj[ifnev].pinfo.soilUse);
			ifnhead.rows.push(row);
		}
		
		// canopyCoverPerc (IFN2)
		if (ifnsobj[ifnev].pinfo.canopyCoverPerc) {
			row = {};
			row.head = getLiteral(dict.canopyCover);
			row.value = ifnsobj[ifnev].pinfo.canopyCoverPerc + "%";
			ifnhead.rows.push(row);
		}
	
		// plantCoverPerc (IFN2)
		/*if (ifnsobj[ifnev].pinfo.plantCoverPerc) {
			row = {};
			row.head = getLiteral(dict.plantCover);
			row.value = ifnsobj[ifnev].pinfo.plantCoverPerc + "%";
			ifnhead.rows.push(row);
		}*/
	
		// altitude
		if (ifnsobj[ifnev].pinfo.altitudeM) {
			row = {};
			row.head = getLiteral(dict.altitude);
			row.value = ifnsobj[ifnev].pinfo.altitudeM  + 'm';
			ifnhead.rows.push(row);
		}
	
		// province
		if (ifnsobj[ifnev].pinfo.province) {
			row = {};
			row.head = getLiteral(dict.province);
			row.value = getLiteral(ifnsobj[ifnev].pinfo.province);
			ifnhead.rows.push(row);
		}
		
		// municipality	
		if (ifnsobj[ifnev].pinfo.municipality) {
			row = {};
			row.head = getLiteral(dict.municipality);
			row.value = getLiteral(ifnsobj[ifnev].pinfo.municipality);
			ifnhead.rows.push(row);
		}
		
		// parcela existencias
		if (ifnsobj[ifnev].pinfo.plotexs) {
			row = {};
			row.head = getLiteral(dict.plotexs);
			row.value = '<button iri="' + ifnsobj[ifnev].pinfo.plotexs + '" class="plot btn btn-primary" type="button">'
				+ getLiteral(dict.viewstockplot) + '</button>';
			ifnhead.rows.push(row);
		}
		
		// parcela comparación
		if (ifnsobj[ifnev].pinfo.plotcomp) {
			row = {};
			row.head = getLiteral(dict.plotcomp);
			row.value = '<button iri="' + ifnsobj[ifnev].pinfo.plotcomp + '" class="plot btn btn-primary" type="button">'
				+ getLiteral(dict.viewcompplot) + '</button>';
			ifnhead.rows.push(row);
		}	
		
		// parcela IFN2 en caso notComparable
		if (ifnsobj[ifnev].pinfo.plotifn2 && ifnsobj[ifnev].pinfo.notComparable) {
			row = {};
			row.head = getLiteral(dict.plotifn2);
			row.value = '<button iri="' + ifnsobj[ifnev].pinfo.plotifn2 + '" class="plot btn btn-primary" type="button">'
				+ getLiteral(dict.viewplotifn2) + '</button>';
			ifnhead.rows.push(row);
		}
		
		// parcela IFN3 en caso notComparable
		if (ifnsobj[ifnev].pinfo.plotifn3 && ifnsobj[ifnev].pinfo.notComparable) {
			row = {};
			row.head = getLiteral(dict.plotifn3);
			row.value = '<button iri="' + ifnsobj[ifnev].pinfo.plotifn3 + '" class="plot btn btn-primary" type="button">'
				+ getLiteral(dict.viewplotifn3) + '</button>';
			ifnhead.rows.push(row);
		}		
	}
	
	// preparo colspanifn, común a todas las tablas
	const colspanifn = ifns.length == 0? '': ' colspan="'+ifns.length+'"';
	
	// extraigo datos del infoSpeciesStock
	const species = [];
	const measures = [	
		{ 
			id: "numberTreesHa",
			label: getLiteral(dict.numbertreesHA),
			unit: getLiteral(dict.treesHA),
			ndecs: 2
		},
		{ 
			id: "basalAreaM2byHa",
			label: getLiteral(dict.basalareaM2HA),
			unit: "m2/ha",
			ndecs: 2
		},
		{ 
			id: "volumeWithBarkM3byHa",
			label: getLiteral(dict.volumewithbarkM3HA),
			unit: "m3/ha",
			ndecs: 2
		},
		{ 
			id: "volumeWithoutBarkM3byHa",
			label: getLiteral(dict.volumewithoutbarkM3HA),
			unit: "m3/ha",
			ndecs: 2
		}
	];
	const datasets = {}; // uno por cada tipo de medida
	for (const measure of measures) {
		datasets[measure.id] = [];
		for (const evifn of ifns) {
			if (ifnsobj[evifn].pinfo.infoSpeciesStock) {
				// preparo dataset de evifn
				const ds = {
					label: ifnsobj[evifn].ifnlab,
					unit: measure.unit,
					data: [],
					backgroundColor: [],
					//backgroundColor: colsifn[evifn],
					hoverOffset: 4,
					ifn: evifn
				};
				//convierto en array el infoSpeciesStock (si existe)			
				const iss = Array.isArray(ifnsobj[evifn].pinfo.infoSpeciesStock)? 
					ifnsobj[evifn].pinfo.infoSpeciesStock : [ ifnsobj[evifn].pinfo.infoSpeciesStock ];
				for (const issel of iss) {
					// etiqueta de especie
					const splab = getTaxonLabel(issel.species, Sesion.nomci);
					// si no está en el array, lo incluyo
					if (!species.includes(splab))
						species.push(splab);
					// si existe el valor, lo guardo
					if (issel[measure.id]) {						
						// recupero el índice de la especie
						const ind = species.indexOf(splab);
						if (ds.data[ind]) // para el caso raro en que hay que sumar stock, e.g.: pifn3:40-716-A-3E
							ds.data[ind] += issel[measure.id];
						else				
							ds.data[ind] = issel[measure.id];
					}
				}
				datasets[measure.id].push(ds);
				opl.hayISS = true; // para que lo renderice
			}
		}
	}
	// reajuste colores de cada dataset (indcols lo uso también en las clases diamétricas)
	const indcols = config.indcols[species.length - 1]; // extraigo el array con los índices según el número de especies
	if (opl.hayISS) {
		for (const measure of measures) {
			for (const ds of datasets[measure.id]) {
				//const irowc = indcolifns[ds.label];
				const irowc = Sesion.colifnind[ds.ifn];
				for (const icolc of indcols)
					ds.backgroundColor.push(config.colores[irowc][icolc]);
			}
		}
		// preparo tablaISS
		opl.tisshead = [];
		opl.tissrows = [];
		// cabecera
		//opl.tisshead.push('<th scope="col">' + getLiteral(dict.measure) + '</th>' );
		opl.tisshead.push('<th scope="col"></th>' );
		for (const sp of species) {
			const splab = Sesion.nomci? '<i>' + sp + '</i>' : sp;
			opl.tisshead.push('<th scope="col"' + colspanifn + ' class="text-center">' + splab + '</th>' );
		}
		if (ifns.length > 1) {
			opl.haytisshead2 = true;
			opl.tisshead2 = [];
			opl.tisshead2.push('<th scope="col"></th>' );
			for (const sp of species) {
				for (const ifnev of ifns)
					opl.tisshead2.push('<th scope="col" class="text-center">' + ifnsobj[ifnev].ifnlab + '</th>' );
			}
		}
		// filas
		for (const measure of measures) {
			const row = {};
			row.head = measure.label;
			row.els = [];
			for (const sp of species) {
				const ind = species.indexOf(sp);
				for (const ifnev of ifns) {
					const ds = datasets[measure.id].find((el) => el.ifn === ifnev);
					if (ds && ds.data[ind])
						row.els.push(Number(ds.data[ind]).toFixed(measure.ndecs));
					else
						row.els.push('');
				}
			}
			// incluyo fila medida
			opl.tissrows.push(row);
		}
	}
		
	// extraigo datos de las especies por clase diamétrica
	// reutilizo species, measures, cols y colsifn (REHACER COLORES)
	let valoresDC = []; // valores de clase diamétrica
	const medidasDC = {}; // medidas por especie, ifn y DC
	for (const evifn of ifns) {
		//convierto en array el infoSpeciesByDiameterClass (si existe)
		if (ifnsobj[evifn].pinfo.infoSpeciesByDiameterClass) {
			const isdc = Array.isArray(ifnsobj[evifn].pinfo.infoSpeciesByDiameterClass)? 
				ifnsobj[evifn].pinfo.infoSpeciesByDiameterClass : [ ifnsobj[evifn].pinfo.infoSpeciesByDiameterClass ];
			for (const isdcel of isdc) {
				// sólo tiene sentido si hay especie y clase diamétrica
				if (isdcel.species && isdcel.diameterClass) {			
					// etiqueta de especie
					const splab = getTaxonLabel(isdcel.species, Sesion.nomci);
					// creo objeto de medidasDC de la especie si hace falta
					if (!medidasDC[splab])
						medidasDC[splab] = {};
					// extraigo valor de clase diamétrica
					const vdc = Number(isdcel.diameterClass.substring(isdcel.diameterClass.length -2, isdcel.diameterClass.length));
					// incluyo valor de DC si no estaba
					if (!valoresDC.includes(vdc))
						valoresDC.push(vdc);
					//console.log(evifn +" - " + splab + " - " + vdc);
					// guardo medidas
					for (const measure of measures) {
						const mid = measure.id;
						if (!medidasDC[splab][mid])
							medidasDC[splab][mid] = {};
						if (!medidasDC[splab][mid][evifn])
							medidasDC[splab][mid][evifn] = {};
						if (isdcel[mid]) {
							medidasDC[splab][mid][evifn][vdc] = isdcel[mid];
							opl.hayDC = true; // para que lo renderice
						}
					}
				}
			}
		}
	}
	
	// preparo los datasets de clases diamétricas
	// ordeno valoresDC
	valoresDC = valoresDC.sort((a, b) => a-b);
	const datasetsDC = {}; // uno por tipo de medida
	if (opl.hayDC) {
		for (const measure of measures) {
			datasetsDC[measure.id] = []; // inicializo
			for (const evifn of ifns) {  // TODO: cuidado con esto => HACER STACKING SI HAY VARIOS
				const evifnlab = getLiteral(dict[evifn.toUpperCase()]);
				const irowc = Sesion.colifnind[evifn];
				for (const splab of species) {
					// obtengo índice de la especie para el color
					const icolc = indcols[species.indexOf(splab)];
					// preparo dataset por especie
					const ds = {
						label: evifnlab+'-'+splab,
						unit: measure.unit,
						data: [],
						backgroundColor: config.colores[irowc][icolc],
						stack: evifn, // hago stacking for IFN
						hoverOffset: 4,
						ifn: evifn
					};				
					// guardo valores
					let algoEnDataset = false;
					for (const vdc of valoresDC) {
						// si existe el valor, lo guardo
						if (medidasDC[splab][measure.id][evifn] && medidasDC[splab][measure.id][evifn][vdc]) {					
							// recupero el índice de la clase diamétrica
							const ind = valoresDC.indexOf(vdc);
							if (ds.data[ind]) // para el caso raro en que hay que sumar stock, e.g.: pifn3:40-716-A-3E
								ds.data[ind] += medidasDC[splab][measure.id][evifn][vdc];
							else			
								ds.data[ind] = medidasDC[splab][measure.id][evifn][vdc];
							algoEnDataset = true;
						}
					}
					// guardo dataset
					if (algoEnDataset)
						datasetsDC[measure.id].push(ds);
				}
			}
		}		
		// preparo tablaDC
		opl.tdchead = [];
		opl.tdcrows = [];
		// cabecera
		opl.tdchead.push('<th scope="col"></th>' );
		for (const vdc of valoresDC)
			opl.tdchead.push('<th scope="col"' + colspanifn + ' class="text-center">' + vdc + 'cm</th>' );
		if (ifns.length > 1) {
			opl.haytdchead2 = true;
			opl.tdchead2 = [];
			opl.tdchead2.push('<th scope="col"></th>' );
			for (const vdc of valoresDC) {
				for (const ifnev of ifns)
					opl.tdchead2.push('<th scope="col" class="text-center">' + ifnsobj[ifnev].ifnlab + '</th>' );
			}
		}
		const ncols = 1 + valoresDC.length*ifns.length;
		for (const measure of measures) {
			// cabecera		
			opl.tdcrows.push('<tr class="table-secondary text-center"><th scope="row" colspan="'+ncols+'">' + measure.label + '</th></tr>');
			for (const sp of species) {
				const ind = species.indexOf(sp);
				const splab = Sesion.nomci? '<i>' + sp + '</i>' : sp;
				let row = '<tr><th scope="col">' + splab + '</th>';
				const med = medidasDC[sp][measure.id]; // ref
				for (const vdc of valoresDC) {
					for (const ifnev of ifns) {
						row += '<td class="text-center">';
						if (med[ifnev] && med[ifnev][vdc])
							row += Number(med[ifnev][vdc]).toFixed(measure.ndecs);
						row += '</td>';
					}
				}
				row += '</tr>';
				// incluyo fila medida
				opl.tdcrows.push(row);
			}
		}
	}
	
	// tabla árboles
	if (opl.hayMapa) {	
		// inicializo tabla árboles
		opl.thead = [];
		opl.trows = [];
		// cabecera
		//opl.thead.push('<th scope="col">' + getLiteral(dict.tree) + '</th>' );
		opl.thead.push('<th scope="col"' + colspanifn + ' class="text-center">' + getLiteral(dict.order) + '</th>' );
		opl.thead.push('<th scope="col" class="text-center">' + getLiteral(dict.speciesmin) + '</th>' );
		opl.thead.push('<th scope="col"' + colspanifn + ' class="text-center">' + getLiteral(dict.heightm) + '</th>' );
		opl.thead.push('<th scope="col"' + colspanifn + ' class="text-center">' + getLiteral(dict.diametermm) + '</th>' );
		opl.thead.push('<th scope="col"' + colspanifn + ' class="text-center">' + getLiteral(dict.basalareaTree) + '</th>' );
		opl.thead.push('<th scope="col"' + colspanifn + ' class="text-center">' + getLiteral(dict.volumewithbarkTree) + '</th>' );
		opl.thead.push('<th scope="col"' + colspanifn + ' class="text-center">' + getLiteral(dict.volumewithoutbarkTree) + '</th>' );
		opl.thead.push('<th scope="col"' + colspanifn + ' class="text-center">' + getLiteral(dict.volumefirewoodTree) + '</th>' );
		if (ifns.length > 1) {
			opl.haythead2 = true;
			opl.thead2 = [];
			//opl.thead2.push('<th scope="col"></th>');			
			for (const ifnev of ifns)
				opl.thead2.push('<th scope="col" class="text-center">' + ifnsobj[ifnev].ifnlab + '</th>' );
			opl.thead2.push('<th scope="col"></th>');
			for (let i=0; i<opl.thead.length - 2; i++) {
				for (const ifnev of ifns)
					opl.thead2.push('<th scope="col" class="text-center">' + ifnsobj[ifnev].ifnlab + '</th>' );
			}
		}
		// preparo datos de árboles en una primera pasada (se utilizarán también en el mapa para los marcadores)
		const intPendientes = {};
		opl.trees = [];
		for (const evifn of ifns) {
			const arboles = !ifnsobj[evifn].pinfo.trees? [] : Array.isArray(ifnsobj[evifn].pinfo.trees)? 
				ifnsobj[evifn].pinfo.trees : [ ifnsobj[evifn].pinfo.trees ];
			for (const arb of arboles) {
				// sólo lo considero si tiene altura mayor que 0 
				if (arb.heightM > 0) {
					const tree = {
						iri: arb.iri,
						ifn: evifn,
						pintable: !!(arb.lat && arb.lng),
						//id: uriToLiteral(arb.iri, "tree-"), // ya no lo uso
						lat: arb.lat,
						lng: arb.lng,
						integra: [],
						popup: {}
					};
					tree.popup[evifn] = arb;
					tree.popup[evifn].dataCapture = ifnsobj[evifn].pinfo.dataCapture; // de la parcela
					// si este árbol está pendiente de integrarse, lo completo
					if (intPendientes[tree.iri]) {
						const otree = opl.trees.find((el) => el.iri === intPendientes[tree.iri]);
						// integro tree en otree
						otree.popup[evifn] = tree.popup[evifn];
						otree.integra.push(tree.iri);						
						// actualizo id
						//if (typeof otree.id === "string") {
						//	const idorext = otree.id + " (" + ifnsobj[otree.ifn].ifnlab + ")";
						//	otree.id = [ idorext ];
						//}
						//otree.id.push( tree.id + " (" + ifnsobj[tree.ifn].ifnlab + ")" );
						// ajustes de lat, lng y pintable
						if (!otree.lat && tree.lat)
							otree.lat = tree.lat;						
						if (!otree.lng && tree.lng)
							otree.lng = tree.lng;
						if (otree.lng && otree.lng)
							otree.pintable = true;
						// ya no está pendiente
						delete intPendientes[tree.iri]
						// al integrarse, ya no hay que meterlo en opl.trees
					}
					else {					
						// detecto si este árbol es integrable con otros de otros inventarios
						for (const intifn of ifns) {
							// programo integración si hay mapeo y SI ES ÚNICO
							if (intifn !== evifn && arb["tree"+intifn] && typeof arb["tree"+intifn] === "string") 
								intPendientes[arb["tree"+intifn]] = tree.iri;
						}
						// añado a la lista
						opl.trees.push(tree);
					}
				}		
			}
		}
		// en esta segunda pasada preparo los iconos
		for (const tree of opl.trees) {
			// si integra varios árboles, pongo -1 para recuperar el icono normal (verde)
			const icol = tree.integra.length > 0? -1 : Sesion.colifnind[tree.ifn];
			tree.icon = getIconoArbol(tree.popup[tree.ifn], icol);			
			// reajusto id
			//if (Array.isArray(tree.id))
			//	tree.id = tree.id.join(" ");
		}
		// ordeno por ifn y luego por order
		opl.trees.sort((a, b) => {
			if (a.ifn === b.ifn)
				return a.popup[a.ifn].order - b.popup[b.ifn].order; // ahora ordeno por orden
			else
				return a.ifn.localeCompare(b.ifn);
		});
		// filas árboles
		//for (const tree of opl.trees) {
		for (let ind = 0; ind < opl.trees.length; ind++) {
			const tree = opl.trees[ind];
			const row = { ind: ind }; // incluyo el índice
			//row.head = tree.id;
			row.els = [];
			// orden
			for (const ifnev of ifns) {
				if (tree.popup[ifnev] && tree.popup[ifnev].order)
					row.els.push(tree.popup[ifnev].order);
				else
					row.els.push('');
			}	
			// especie 
			let txlabdist = false;
			let txlabcorta = null;
			let txlabexp = null;
			for (const ifnev of ifns) {
				if (tree.popup[ifnev]) {
					const txuri = getMoreSpecificTaxon(tree.popup[ifnev].species);
					const txlab = getTaxonLabel(txuri, Sesion.nomci, true);
					// compruebo si hay cambio de especie
					if (txlabcorta && txlabcorta !== txlab)
						txlabdist = true;
					// actualizo etiqueta corta 
					txlabcorta = txlab;
					// preparo etiqueta expandida
					txlabexp = txlabexp? txlabexp + "<br>" + txlab + " (" + ifnsobj[ifnev].ifnlab + ")" 
						: txlab + " (" + ifnsobj[ifnev].ifnlab + ")";
				}
			}
			if (txlabdist)
				row.els.push(txlabexp);
			else
				row.els.push(txlabcorta);
			// altura
			for (const ifnev of ifns) {
				if (tree.popup[ifnev] && tree.popup[ifnev].heightM && tree.popup[ifnev].heightM > 0)
					row.els.push(Number(getLiteral(tree.popup[ifnev].heightM)).toFixed(2));
				else
					row.els.push('');
			}
			// diámetro
			for (const ifnev of ifns) {
				let algo = false;
				if (tree.popup[ifnev] && tree.popup[ifnev].dbh1mm && tree.popup[ifnev].dbh2mm) {
					const dbh1 = getLiteral(tree.popup[ifnev].dbh1mm);
					const dbh2 = getLiteral(tree.popup[ifnev].dbh2mm);
					if (dbh1 && dbh2) { // media aritmética
						row.els.push((dbh1 + dbh2)/2);
						algo = true;
					}
				}
				if (!algo)
					row.els.push('');
			}			
			// área basimétrica
			for (const ifnev of ifns) {
				if (tree.popup[ifnev] && tree.popup[ifnev].basalAreaM2)
					row.els.push(Number(getLiteral(tree.popup[ifnev].basalAreaM2)).toFixed(4));
				else
					row.els.push('');
			}	
			// volumen con corteza
			for (const ifnev of ifns) {
				if (tree.popup[ifnev] && tree.popup[ifnev].volumeWithBarkdm3)
					row.els.push(Number(getLiteral(tree.popup[ifnev].volumeWithBarkdm3)).toFixed(2));
				else
					row.els.push('');
			}			
			// volumen sin corteza
			for (const ifnev of ifns) {
				if (tree.popup[ifnev] && tree.popup[ifnev].volumeWithoutBarkdm3)
					row.els.push(Number(getLiteral(tree.popup[ifnev].volumeWithoutBarkdm3)).toFixed(2));
				else
					row.els.push('');
			}
			// volumen leña
			for (const ifnev of ifns) {
				if (tree.popup[ifnev] && tree.popup[ifnev].volumeFirewooddm3)
					row.els.push(Number(getLiteral(tree.popup[ifnev].volumeFirewooddm3)).toFixed(2));
				else
					row.els.push('');
			}
			// incluyo fila árbol
			opl.trows.push(row);
		}
	}
	
	// hago el rendering
	const htmlcontent = Mustache.render(plotDashboardTemplate, opl);
	document.getElementById("mipagina").innerHTML = htmlcontent;
	
	// preparo array de marcadores de árboles para la tabla
	const treemarkers = [];

	// envío GA evento ver página parcela
	if (!noTimedEvent)
		sendTimedEvent();

	// handler nombre científico
	document.getElementById("plotchecknomci").addEventListener('change', handlerNombreCientifico);
	
	// handler botón volver
	document.querySelector('.goBack').addEventListener('click', goBack);

	// handler de la versión del ifn de la parcela	
	document.querySelectorAll('.check-ifn-dash').forEach(function(radio) {
		radio.addEventListener('change', function() {
			// compruebo si no hay nada seleccionado			
			const algunifn = Array.from(document.querySelectorAll('.check-ifn-dash'))
				.some((el) => el.checked);
			if (!algunifn) // no dejo no seleccionar nada
				this.checked = true;
			else {
				// extraigo ifn del elemento que cambió
				const elifn = this.getAttribute('ifn');				
				if (this.checked) 
					Sesion.estado.oifns[elifn] = true; // activo para comparación
				else {
					delete Sesion.estado.oifns[elifn];
					if (ifn === elifn) {
						// aquí viene el lío, estoy cambiando el foco
						for (const evifn in Sesion.estado.oifns) {
							// cojo el primero de los otros y a volar
							Sesion.estado.etid = ifnsobj[evifn].piri;
							Sesion.estado.oifns = {};
							break; // sólo trabajo con uno
						}
					}
				}			 			
				// evento con selección edición ifn
				const ifnChecks = document.querySelectorAll('.check-ifn-dash:checked');
				const ifnValues = Array.from(ifnChecks).map(checkbox => checkbox.getAttribute('ifn'));
				const cadifns = 'plot_'+ifnValues.join('_');
				sendEvent( 'select_content', { content_type: cadifns, content_id: Sesion.estado.etid } );				
				
				// reajusto url y actualizo página en la historia
				history.replaceState(Sesion.estado, "", obtenerURL());
				// actualizo el dashboard
				renderDashboard(true);
			}
		});
	});
	
	// handler del color del ifn
	document.querySelectorAll('.color_ifn').forEach(el => {
		el.addEventListener('click', function (ev) {
			// si no pongo esto irá a cargarURL (!)
			ev.preventDefault();			
			// cojo la versión del ifn
			const mifn = this.getAttribute('ifn');
			// cojo el índice del color
			const cind = Number(this.getAttribute('cind'));
			// cambio color
			if (Sesion.colifnind[mifn] != cind) {
				Sesion.colifnind[mifn] = cind;
				// render de nuevo
				renderDashboard(true);			
			}			
		});
	});				
		
	// handlers para el cambio de etiqueta mostrar/esconder y para navegar al árbol que se clicka
	if (opl.hayMapa) {
		// mostrar/esconder
		document.getElementById("botonTablaArboles").addEventListener('click', function(event) {
			// obtengo nueva etiqueta
			const lab = event.target.classList.contains('collapsed')? getLiteral(dict.show) : getLiteral(dict.hide);
			document.getElementById("botonTablaArboles").innerHTML = lab;
		});
		// mostrar marcador del árbol al clickar y scroll		
		document.querySelectorAll("#tablaArboles tbody tr").forEach(function(row) {
			row.addEventListener('click', function() {
    			// recupero el índice
    			const ind = this.getAttribute('ind');
    			// muestro el popup correspondiente
    			treemarkers[ind].openPopup();
    			// scroll al mapa
    			document.getElementById('mapaparcela').scrollIntoView({ behavior: 'smooth', block: 'start' });
    		});
		});		
	}
	if (opl.hayISS) {
		document.getElementById("botonISS").addEventListener('click', function(event) {
			// obtengo nueva etiqueta
			const lab = event.target.classList.contains('collapsed')? getLiteral(dict.show) : getLiteral(dict.hide);
			document.getElementById("botonISS").innerHTML = lab;
		});		
		// handler gráfica / tabla
		document.querySelectorAll('input[type=radio][name=radioISS]').forEach(function(radio) {
			radio.addEventListener('change', function() {
				// escondo o muestro según el valor
				if (document.getElementById("radioISS-chart").checked) {
					document.getElementById("speciesStockChart").classList.remove('d-none');
					document.getElementById("botonInfoSpeciesStock").classList.remove('d-none');
					document.getElementById("tablaISS").classList.add('d-none');		
				}
				else {
					document.getElementById("speciesStockChart").classList.add('d-none');
					document.getElementById("botonInfoSpeciesStock").classList.add('d-none');
					document.getElementById("tablaISS").classList.remove('d-none');	
				}
			});
		});		
	}
	if (opl.hayDC) {
		document.getElementById("botonDC").addEventListener('click', function(event) {
			// obtengo nueva etiqueta
			const lab = event.target.classList.contains('collapsed')? getLiteral(dict.show) : getLiteral(dict.hide);
			document.getElementById("botonDC").innerHTML = lab;
		});		
		// handler gráfica / tabla
		document.querySelectorAll('input[type=radio][name=radioDC]').forEach(function(radio) {
			radio.addEventListener('change', function() {
				// escondo o muestro según el valor
				if (document.getElementById("radioDC-chart").checked) {
					document.getElementById("speciesDCChart").classList.remove('d-none');
					document.getElementById("botonMedidaDC").classList.remove('d-none');
					document.getElementById("tablaDC").classList.add('d-none');		
				}
				else {
					document.getElementById("speciesDCChart").classList.add('d-none');
					document.getElementById("botonMedidaDC").classList.add('d-none');
					document.getElementById("tablaDC").classList.remove('d-none');	
				}
			});
		});		
	}
	
	// pongo el barchart de ISS si hay algo
	if (opl.hayISS) {
		// recupero el canvas
		const ctx = document.getElementById('speciesStockChart');
		// pinto la densidad de árboles
		const barChart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: species,
				datasets: datasets.numberTreesHa
			},
			options: {
				animation: false,
				plugins: {
					tooltip: {
						callbacks: {
							label: function(tooltipItem) {
								return tooltipItem.dataset.label + ': ' + tooltipItem.formattedValue + ' ' + tooltipItem.dataset.unit; //+ ' m3/ha';
							}
						}
					}
				},
				scales: {
					y: {
						beginAtZero: true,
						title: {
							display: true,
							text: measures[0].label
						}
					}
				}
			}
		});
		// pongo listener al dropdown
		document.querySelectorAll('.isstock').forEach(el => {
			el.addEventListener('click', function (ev) {
				ev.preventDefault();
				// cojo el índice
				const ind = Number(this.getAttribute('ind'));
				// actualizo la base de datos con la medida elegida
				barChart.data.datasets = datasets[measures[ind].id];
				// actualizo escala y
				barChart.options.scales.y.title.text = measures[ind].label.replace("<sup>", "").replace("</sup>", "");
				// cambio etiqueta del botón
				document.getElementById('botonInfoSpeciesStock').innerHTML = ev.target.innerHTML;
				// Refresh the chart
				barChart.update();
			});
		});
	}
	
	// pongo el barchart DC si hay algo
	if (opl.hayDC) {	
		// recupero el canvas
		const ctx = document.getElementById('speciesDCChart');		
		// pinto la densidad de árboles
		const barChart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: valoresDC.map(str => str + " cm"),
				datasets: datasetsDC.numberTreesHa
			},
			options: {
				animation: false,
				plugins: {
					tooltip: {
						callbacks: {
							title: function(tooltipItems) { 
								return tooltipItems[0].label + ' - ' +  tooltipItems[0].dataset.label.split('-')[1]; 
							},
							label: function(tooltipItem) {
								//console.log(tooltipItem);							
								return tooltipItem.dataset.label.split('-')[0] + ': ' + tooltipItem.formattedValue + ' ' + tooltipItem.dataset.unit; //+ ' m3/ha';
							}
						}
					}
				},
				scales: {
					x: {
						stacked: true,
					},
					y: {
						beginAtZero: true,
						stacked: true,
						title: {
							display: true,
							text: measures[0].label
						}
					}
				}
			}
		});
		// listener al dropdown de medida
		document.querySelectorAll('.idcmed').forEach(el => {
			el.addEventListener('click', function (ev) {
				ev.preventDefault();
				// cojo el índice
				const ind = Number(this.getAttribute('ind'));				
				// actualizo la base de datos con la medida elegida
				barChart.data.datasets = datasetsDC[measures[ind].id];
				// actualizo escala y
				barChart.options.scales.y.title.text = measures[ind].label.replace("<sup>", "").replace("</sup>", "");
				// cambio etiqueta del botón y ajusto índice
				document.getElementById('botonMedidaDC').innerHTML = ev.target.innerHTML;
				document.getElementById('botonMedidaDC').setAttribute("ind", ind);
				// Refresh the chart
				barChart.update();
			});
		});
	}
	
	// preparo el mapa si hay árboles que pintar
	if (opl.hayMapa) {
		// preparo primero los bounds para que no se vaya a Cuenca
		const offset = 0.0006; // 1km es aproximadamente 0,008 grados en WGS84
		const bounds = L.latLngBounds(
			L.latLng(ifnsobj[ifn].pinfo.lat - offset, ifnsobj[ifn].pinfo.lng - offset), //southWest
			L.latLng(ifnsobj[ifn].pinfo.lat + offset, ifnsobj[ifn].pinfo.lng + offset)); //northEast			
		const Minimapa = L.map('mapaparcela', {maxBounds: bounds, maxBoundsViscosity: config.geoMaxBoundsViscosity,
				zoomControl: false, tap: false, doubleClickZoom: false, //scrollWheelZoom: 'center', 
				wheelDebounceTime: 100, preferCanvas: true} )
			.setView([ifnsobj[ifn].pinfo.lat, ifnsobj[ifn].pinfo.lng], config.zMiniMapa);
		// cargo el tile layer que corresponda
		const gc = obtenerConfigMapaBaseMini();
		let Mitilelayer = gc.wms? L.tileLayer.wms(gc.url, gc.options).addTo(Minimapa) : L.tileLayer(gc.url, gc.options).addTo(Minimapa);
		
		// REPOSICIONO CONTROLES DE ZOOM Y MUESTRO ESCALA DEL MAPA
		L.control.scale( {imperial: false, position: 'bottomright'} ).addTo(Minimapa); // sin la escala imperial
		if (!L.Browser.mobile) { // sólo botones de zoom para dispositivos no móviles
			L.control.zoom( { position: 'bottomright',
				zoomInTitle: getLiteral(dict.zoomin),
				zoomOutTitle: getLiteral(dict.zoomout),
			} ).addTo(Minimapa);
		}
	
		// pinto los 4 círculos de las parcelas: 5, 10, 15, 25m
		let circulos = pintarCirculos(Minimapa, ifnsobj[ifn].pinfo.lat, ifnsobj[ifn].pinfo.lng);
		
		// pinto los árboles de la parcela
		for (const arb of opl.trees) {
			// sólo los pintables
			if (arb.pintable) {
				// pinto marcador y popup (y lo guardo en treemarkers para usarlo en la tabla)
				treemarkers.push(L.marker([arb.lat, arb.lng], {icon: arb.icon})
					.bindPopup(popupArbolExt(arb.popup, arb.ifn), {maxWidth: 800})
					.addTo(Minimapa));
			}
		}
	
		// botón capa satélite
		const controlBotones = L.Control.extend({
			options: {
				position: 'bottomright'
			},
			onAdd: function (map) {
				// preparo botonera vertical
				const container = L.DomUtil.create('div', "leaflet-bar leaflet-control btn-group-vertical");
				container.setAttribute("role", "group");
						
				// link esri
				const le = L.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single esri", container);
				le.title = getLiteral(dict.satellite);
				le.href = "#";
				le.setAttribute("role", "button");
				const les = L.DomUtil.create('span', 'bi bi-layers-fill', le);
				if (Sesion.estado.mapType === config.mapConfig.mapType[1]) { // satélite
					le.setAttribute("style", "background-color: #6c757d;");
					les.setAttribute("style", "color: white;");
				}
			
				// listener esri
				le.addEventListener('click', function(e) {				
					event.preventDefault(); // Prevent the default behavior of the hyperlink
					// actualizo Sesion.estado.mapType
					Sesion.estado.mapType = Sesion.estado.mapType === config.mapConfig.mapType[0]?
						config.mapConfig.mapType[1] : config.mapConfig.mapType[0];
					// actualizo minimapa
					const newgc = obtenerConfigMapaBaseMini();
					for (let clave of Object.keys(Minimapa.attributionControl._attributions))
						Minimapa.attributionControl.removeAttribution(clave);
					Mitilelayer = newgc.wms? L.tileLayer.wms(newgc.url, newgc.options).addTo(Minimapa) :
						 L.tileLayer(newgc.url, newgc.options).addTo(Minimapa);
					// actualizo aspecto botón
					if (Sesion.estado.mapType === config.mapConfig.mapType[1]) {					
						document.querySelector(".esri").style.backgroundColor = "#6c757d";
						document.querySelector(".esri span").style.color = "white";
					}
					else {					
						document.querySelector('.esri').style.backgroundColor = "";
				        document.querySelector('.esri span').style.color = "";
					}
					// actualizo círculos
					for (const circ of circulos)
						Minimapa.removeLayer(circ);
					circulos = pintarCirculos(Minimapa, ifnsobj[ifn].pinfo.lat, ifnsobj[ifn].pinfo.lng);
				});
				return container;
			}
		});
		Minimapa.addControl(new controlBotones());
	}
}

function pintarCirculos(mm, lat, lng) {
	const imax = config.colores[config.colcircplotind].length - 1;
	// creo los 4 círculos
	const opacint = Sesion.estado.mapType === config.mapConfig.mapType[0]? 0.5 : 0.2;
	const opacext = Sesion.estado.mapType === config.mapConfig.mapType[0]? 0.3 : 0.1;
	const circulos = [];
	circulos.push(L.circle([lat, lng],
		{color: config.colores[config.colcircplotind][imax-6], weight: 1, radius: config.radioParcelaN3, fillOpacity: opacint})
		.addTo(mm));
	circulos.push(L.circle([lat, lng],
		{color: config.colores[config.colcircplotind][imax-4], weight: 1, radius: config.radioParcelaN2, fillOpacity: opacext})
		.addTo(mm));
	circulos.push(L.circle([lat, lng],
		{color: config.colores[config.colcircplotind][imax-2], weight: 1, radius: config.radioParcelaN1, fillOpacity: opacext})
		.addTo(mm));
	circulos.push(L.circle([lat, lng],
		{color: config.colores[config.colcircplotind][imax], weight: 1, radius: config.radioParcelaN0, fillOpacity: opacext})
		.addTo(mm));
	return circulos;
}

function obtenerConfigMapaBaseMini() {
	if (Sesion.estado.mapType === config.mapConfig.mapType[1]) // "satellite"
		return config.geoConfigs.esriMini;
	else	// "default"
		return config.geoConfigs.voyagerMini;
}

function popupArbolExt(arbpopup, ifn) {	
	// preparo plantilla para el mustache
	let arbtemp = {};
	// nombre árbol
	arbtemp.tree = getLiteral(dict.tree) + " " + uriToLiteral(arbpopup[ifn].iri, "tree-");
	// fuente
	arbtemp.source = getLiteral(dict["source"+ifn]);
	
	// encabezado (versiones IFN)
	arbtemp.head = [];
	arbtemp.head.push('<th scope="col">'+getLiteral(dict.source)+'</th>');

	// datos de la tabla
	arbtemp.rows = [];
	
	// incluyo fila fuente (encabezado)
	for (let ifnev in arbpopup)
		arbtemp.head.push( '<th scope="col" class="text-end">' + getLiteral(dict["url"+ifnev]) + '</th>' );
	// si sólo hay datos de una versión no pongo tabla
	if (Object.keys(arbpopup).length == 1)
		arbtemp.notabla = true;
	
	// id del árbol
	let row = {};
	if (Object.keys(arbpopup).length > 1) {
		row.head = getLiteral(dict.treemin);
		row.els = [];
		for (let ifnev in arbpopup)
			row.els.push(uriToLiteral(arbpopup[ifnev].iri, "tree-"));
		arbtemp.rows.push(row);
	}
	
	// #orden del árbol
	row = {};
	row.head = getLiteral(dict.order);
	row.els = [];
	for (let ifnev in arbpopup)
		row.els.push(arbpopup[ifnev].order);
	arbtemp.rows.push(row);
	
	// dataCapture
	row = {};
	row.head = getLiteral(dict.plotDate);
	row.els = [];
	let hayalgo = false;
	for (let ifnev in arbpopup) {
		let dclab = getDate(arbpopup[ifnev].dataCapture);
		if (dclab)
			hayalgo = true;
		else
			dclab = '';
		row.els.push(dclab);
	}
	if (hayalgo) {
		if (Object.keys(arbpopup).length > 1)
			arbtemp.rows.push(row);
		else
			arbtemp.dataCapture = getLiteral(dict.dataCapture) + " " + row.els[0];
	}
	
	// especie
	row = {};
	row.head = getLiteral(dict.speciesmin);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let nesp = '';
		const txuri = getMoreSpecificTaxon(arbpopup[ifnev].species);
		if (txuri && Datos.taxones[txuri].vulgarName)
			nesp = getTaxonLabel(txuri, Sesion.nomci, true);
		if (nesp !== '')
			hayalgo = true;
		row.els.push(nesp);
	}
	if (hayalgo)
		arbtemp.rows.push(row);	
		
	// altura
	row = {};
	row.head = getLiteral(dict.heightm);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let alt = '';
		if (arbpopup[ifnev].heightM && arbpopup[ifnev].heightM > 0) {
			alt = Number(getLiteral(arbpopup[ifnev].heightM)).toFixed(2);
			hayalgo = true;
		}
		row.els.push(alt);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	// diámetro
	row = {};
	row.head = getLiteral(dict.diametermm);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let dbh = '';
		if (arbpopup[ifnev].dbh1mm && arbpopup[ifnev].dbh2mm) {
			const dbh1 = getLiteral(arbpopup[ifnev].dbh1mm);
			const dbh2 = getLiteral(arbpopup[ifnev].dbh2mm);
			if (dbh1 && dbh2) { // media aritmética
				dbh = (dbh1 + dbh2)/2;
				hayalgo = true;
			}		
		}
		row.els.push(dbh);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	/*
	// factor expansión
	row = {};
	row.head = getLiteral(dict.expanTree);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let expan = '';
		if (arbpopup[ifnev].expan) {
			expan = Number(getLiteral(arbpopup[ifnev].expan)).toFixed(4);
			hayalgo = true;
		}
		row.els.push(expan);
	}
	if (hayalgo)
		arbtemp.rows.push(row);*/
	
	// área basimétrica
	row = {};
	row.head = getLiteral(dict.basalareaTree);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let ba = '';
		if (arbpopup[ifnev].basalAreaM2) {
			ba = Number(getLiteral(arbpopup[ifnev].basalAreaM2)).toFixed(4);
			hayalgo = true;
		}
		row.els.push(ba);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	// volumen con corteza
	row = {};
	row.head = getLiteral(dict.volumewithbarkTree);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let vol = '';
		if (arbpopup[ifnev].volumeWithBarkdm3) {
			vol = Number(getLiteral(arbpopup[ifnev].volumeWithBarkdm3)).toFixed(2);
			hayalgo = true;
		}
		row.els.push(vol);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	// volumen sin corteza
	row = {};
	row.head = getLiteral(dict.volumewithoutbarkTree);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let vol = '';
		if (arbpopup[ifnev].volumeWithoutBarkdm3) {
			vol = Number(getLiteral(arbpopup[ifnev].volumeWithoutBarkdm3)).toFixed(2);
			hayalgo = true;
		}
		row.els.push(vol);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	// volumen de leña
	row = {};
	row.head = getLiteral(dict.volumefirewoodTree);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let vol = '';
		if (arbpopup[ifnev].volumeFirewooddm3) {
			vol = Number(getLiteral(arbpopup[ifnev].volumeFirewooddm3)).toFixed(2);
			hayalgo = true;
		}
		row.els.push(vol);
	}
	if (hayalgo)
		arbtemp.rows.push(row);
	
	// incremento de volumen
	row = {};
	row.head = getLiteral(dict.volumeincreaseTree);
	row.els = [];
	hayalgo = false;
	for (let ifnev in arbpopup) {
		let vol = '';
		if (arbpopup[ifnev].volumeIncreasedm3) {
			vol = Number(getLiteral(arbpopup[ifnev].volumeIncreasedm3)).toFixed(2);
			hayalgo = true;
		}
		row.els.push(vol);
	}
	if (hayalgo)
		arbtemp.rows.push(row);			
	
			
	// obtengo el popup y lo devuelvo
	return Mustache.render(treePopupTemplate, arbtemp);
}


function goBack() {
	// si hay más páginas en la historia simplemente voy para atrás
	if (Sesion.npags > 0) {
		Sesion.npags--;
		history.back();
	}
	else {	// en otro caso, pongo una página más y voy al mapa
		// actualizo path y URL
		Sesion.estado.path = "map";
		Sesion.npags++;
		history.pushState(Sesion.estado, "", obtenerURL());		
		// y cargo la URL para que me lleve al mapa completo
		cargarURL();
	}
}
	
export { dashboardParcela };